import React, { useState, useEffect, useRef, useMemo } from 'react';

// Ruteador
import { useNavigate } from "react-router-dom";

// Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBallotCheck } from "@fortawesome/pro-duotone-svg-icons";
import { faBadgeCheck } from "@fortawesome/pro-duotone-svg-icons";
import { faDownload } from "@fortawesome/pro-duotone-svg-icons";
import { faEnvelope } from "@fortawesome/pro-duotone-svg-icons";

import { Popup } from 'devextreme-react/popup';

import { get, post } from 'aws-amplify/api';

import { fetchAuthSession } from 'aws-amplify/auth';

import amplifyconfig from '../amplify_outputs.json';

//Form
import Form, { Item, Label, Tab, TabbedItem, TabPanelOptions, GroupItem, ButtonItem, ButtonOptions, RequiredRule } from 'devextreme-react/form';

import RegexParser from 'regex-parser';

import {
    EmailRule,
    PatternRule
} from 'devextreme-react/validator';

// Grid
import { DataGrid, Column, Editing, Format } from 'devextreme-react/data-grid';

// Lodash
import _ from 'lodash';

// LoadPanel
import { LoadPanel } from 'devextreme-react/load-panel';

// Sweet Alert
import Swal from 'sweetalert2'

import '../ListStyle.css';

import dxNumberBox from "devextreme/ui/number_box";

import dxDateBox from "devextreme/ui/date_box";

import Lambda from 'aws-sdk/clients/lambda';

// Sufijo de entorno (sandbox/dev/prod) derivado del backend desplegado.
// custom.API expone una clave tipo 'kioscoAPI-<env>'; usamos ese <env> para
// invocar las Lambdas con el nombre correcto en cada entorno.
const ENV_SUFFIX = Object.keys(amplifyconfig?.custom?.API ?? {})[0]?.replace(/^kioscoAPI-/, '') ?? 'sandbox';

dxNumberBox.defaultOptions({
    options: {
        step: 0
    }
});

dxDateBox.defaultOptions({
    options: {
        dateSerializationFormat: "yyyy-MM-dd"
    }
});


export default function Invoice(props) {
    const navigate = useNavigate();

    const [styles, setStyles] = useState({});
    const [popupVisible, setPopupVisible] = useState(false);
    const [invoiceCfg, setInvoiceCfg] = useState({
        custrecord_al_kiosco_cfg_body_home: '<div></div>',
        secciones: [],
        campos: []
    });
    const [catalogs, setCatalogs] = useState({});

    const [fieldEditorOptions, setFieldEditorOptions] = useState({});

    const [invoicePayload, setInvoicePayload] = useState({});
    const [tickets, setTickets] = useState([]);
    const [newTicket, setNewTicket] = useState({});

    const [isRefreshing, setIsRefreshing] = useState(false);

    const [btnSearchDisabled, setBtnSearchDisabled] = useState(false);

    //Ref para el form
    const [formDatosGeneralesRef, setFormDatosGeneralesRef] = useState(React.createRef());
    const [formInstance, setFormInstance] = useState('');

    //Ref para el grid Tablero de Control
    const [gridTicketsRef, setGridTicketsRef] = useState(React.createRef());

    const [visibleLoadPanel, setVisibleLoadPanel] = useState(false);

    const ticketButton = React.useCallback(async () => {
        setPopupVisible(true);
    }, []);

    const invoiceButton = React.useCallback(async () => {
        var numeroTickets = tickets.length;
        var numeroTicketsFacturados = 0;

        if (numeroTickets <= 0) {
            Swal.fire({
                title: 'Error!',
                text: invoiceCfg.custrecord_al_kiosco_cfg_no_ticket,
                icon: 'error',
                cancelButtonText: 'Cerrar'
            });

            return;
        }
        if (formDatosGeneralesRef.current) {
            var formDatosGenerales = formDatosGeneralesRef.current.instance();
            var isValid = formDatosGenerales.validate();

            if (!isValid.isValid) {
                Swal.fire({
                    title: 'Error!',
                    text: isValid.brokenRules[0].message,
                    icon: 'error',
                    cancelButtonText: 'Cerrar'
                });

                return;
            }
        }

        for (var ticketIndex in tickets) {
            var ticket = tickets[ticketIndex];

            if (ticket.filename) {
                numeroTicketsFacturados++;
            }
        }

        if (numeroTickets === numeroTicketsFacturados) {
            Swal.fire({
                title: invoiceCfg.custrecord_al_kiosco_cfg_prev_fac,
                icon: 'info',
                cancelButtonText: 'Cerrar'
            });

            return;
        }

        var lambdaFunction;

        lambdaFunction = `kioscoCertifyTransaction-${ENV_SUFFIX}`;

        const currentCredentials = (await fetchAuthSession({ forceRefresh: true })).credentials;

        const lambda = new Lambda({
            credentials: {
                accessKeyId: currentCredentials.accessKeyId,
                secretAccessKey: currentCredentials.secretAccessKey,
                sessionToken: currentCredentials.sessionToken
            },
            region: 'us-east-2'
        });

        var params = {
            FunctionName: lambdaFunction,
            Payload: JSON.stringify({
                payload: invoicePayload,
                tickets: tickets
            })
        };

        setVisibleLoadPanel(true);
        
        lambda.invoke(params, function (err, data) {
            console.log('err', err);
            if (err) {
                setVisibleLoadPanel(false);

                Swal.fire({
                    title: 'Error!',
                    text: err.message,
                    icon: 'error',
                    cancelButtonText: 'Cerrar'
                });
            }
            else {
                setVisibleLoadPanel(false);

                var dataGet = JSON.parse(JSON.parse(data.Payload).body);

                if (dataGet.success) {
                    setInvoicePayload(dataGet.payload);
                    setTickets(dataGet.tickets);

                    var gridTickets = gridTicketsRef.current.instance();

                    gridTickets.refresh();

                    Swal.fire({
                        title: invoiceCfg.custrecord_al_kiosco_cfg_concluido,
                        icon: 'success',
                        cancelButtonText: 'Cerrar'
                    });
                }
                else {
                    setInvoicePayload(dataGet.payload);

                    Swal.fire({
                        title: 'Error!',
                        text: dataGet.message,
                        icon: 'error',
                        cancelButtonText: 'Cerrar'
                    });
                }
            }
        });

    }, [tickets, invoiceCfg, formDatosGeneralesRef, invoicePayload, gridTicketsRef]);

    const emailButton = React.useCallback(async () => {
        var numeroTickets = tickets.length;
        var numeroTicketsFacturados = 0;

        if (numeroTickets <= 0) {
            Swal.fire({
                title: 'Error!',
                text: invoiceCfg.custrecord_al_kiosco_cfg_correo_no_en,
                icon: 'error',
                cancelButtonText: 'Cerrar'
            });

            return;
        }

        if (!invoicePayload.email) {
            Swal.fire({
                title: 'Error!',
                text: 'Favor de especificar el correo electrónico',
                icon: 'error',
                cancelButtonText: 'Cerrar'
            });

            return;
        }

        for (var ticketIndex in tickets) {
            var ticket = tickets[ticketIndex];

            if (ticket.filename) {
                numeroTicketsFacturados++;
            }
        }

        if (numeroTicketsFacturados === 0) {
            Swal.fire({
                title: invoiceCfg.custrecord_al_kiosco_cfg_correo_no_en,
                icon: 'info',
                cancelButtonText: 'Cerrar'
            });

            return;
        }

        var lambdaFunction;

        lambdaFunction = `kioscoSendEmail-${ENV_SUFFIX}`;

        const currentCredentials = (await fetchAuthSession()).credentials;

        const lambda = new Lambda({
            credentials: {
                accessKeyId: currentCredentials.accessKeyId,
                secretAccessKey: currentCredentials.secretAccessKey,
                sessionToken: currentCredentials.sessionToken
            },
            region: 'us-east-2'
        });

        var emailPayload = {
            "email": (invoicePayload ? invoicePayload.email : ''),
            "razonsocial": (invoicePayload ? invoicePayload.razonsocial : ''),

            "tickets": []
        };

        for (var ticketIndex in tickets) {
            var ticket = tickets[ticketIndex];

            if (ticket.filename) {
                emailPayload.tickets.push({
                    "custbody_edoc_generated_pdf": ticket.custbody_edoc_generated_pdf,
                    "custbody_psg_ei_certified_edoc": ticket.custbody_psg_ei_certified_edoc,
                    "facturaId": ticket.facturaId,
                    "facturaRecordType": ticket.facturaRecordType,
                    "ticketD": ticket.ticketD,
                    "fechaD": ticket.fechaD,
                    "importeD": ticket.importeD
                });
            }
        }

        var params = {
            FunctionName: lambdaFunction,
            Payload: JSON.stringify({
                emailPayload
            })
        };

        setVisibleLoadPanel(true);

        lambda.invoke(params, function (err, data) {
            if (err) {
                setVisibleLoadPanel(false);

                Swal.fire({
                    title: 'Error!',
                    text: err.message,
                    icon: 'error',
                    cancelButtonText: 'Cerrar'
                });
            }
            else {
                setVisibleLoadPanel(false);

                var dataGet = JSON.parse(JSON.parse(data.Payload).body);

                if (dataGet.success) {
                    Swal.fire({
                        title: invoiceCfg.custrecord_al_kiosco_cfg_correo_enviado,
                        icon: 'success',
                        cancelButtonText: 'Cerrar'
                    });
                }
                else {
                    setInvoicePayload(dataGet.payload);

                    Swal.fire({
                        title: 'Error!',
                        text: dataGet.message,
                        icon: 'error',
                        cancelButtonText: 'Cerrar'
                    });
                }
            }
        });

    }, [invoiceCfg, invoicePayload, tickets]);

    const hidePopupInfo = React.useCallback(() => {
        setPopupVisible(false);
    }, []);

    const renderTicketContent = React.useCallback(() => {
        return (
            <img className="object-contain md:object-cover" src={invoiceCfg.custrecord_al_kiosco_cfg_ticket_ejemplo} alt="Ticket de ejemplo" />
        );
    }, [invoiceCfg]);

    const getStyles = React.useCallback(async () => {
        setVisibleLoadPanel(true);

        try {
            const apiName = 'kioscoAPI';
            const path = '/styles';

            const myInit = {
                headers: {
                    'Content-Type': 'application/json'
                },
                queryStringParameters: {}
            };

            const response = await get({
                apiName,
                path,
                options: myInit
            }).response;

            var stylesGet = await response.body.json();

            if (stylesGet.custrecord_al_kiosco_cfg_mantenimiento && window.location.pathname !== '/Invoice') {
                navigate('/');
            }

            setStyles(stylesGet);
        }
        catch (error) {
            console.error('Error fetching styles:', error);
        }
        finally {
            setVisibleLoadPanel(false);
        }
    }, [navigate]);

    const getInvoiceCfg = React.useCallback(async () => {
        setVisibleLoadPanel(true);

        try {
            const apiName = 'kioscoAPI';
            const path = '/kioscoGetInvoiceCfg';

            const myInit = {
                headers: {
                    'Content-Type': 'application/json'
                },
                queryStringParameters: {}
            };

            const response = await get({
                apiName,
                path,
                options: myInit
            }).response;

            var cfgGet = await response.body.json();

            setInvoiceCfg(cfgGet);

            setFieldEditorOptions(cfgGet.editorOptions);
        }
        catch (error) {
            console.error('Error fetching invoice cfg:', error);
        }
        finally {
            setVisibleLoadPanel(false);
        }
    }, []);

    const getCatalog = React.useCallback(async (catToRefresh, refreshAllData) => {
        setVisibleLoadPanel(true);
        var catalogs_tmp = JSON.parse(JSON.stringify(catalogs));

        for (var catalogoIndex in catToRefresh) {
            var catalogo = catToRefresh[catalogoIndex];

            let apiName = 'kioscoAPI';
            let path = '/kioscoGetCustomerData';

            let options = {
                headers: {
                    'Content-Type': 'application/json'
                },
                body: {
                    payload: invoicePayload,
                    field: catalogo,
                    refreshAllData: refreshAllData
                }
            };

            var response = await post({
                apiName,
                path,
                options
            }).response;

            var datos = await response.body.json();

            catalogs_tmp[catalogo] = datos;
        }

        setCatalogs(catalogs_tmp);

        setVisibleLoadPanel(false);
    }, [catalogs, invoicePayload]);

    useEffect(() => {                
        async function initialize() {
            await getStyles();
            await getInvoiceCfg();
        }

        initialize();

    }, [getInvoiceCfg, getStyles]);

    const onFieldDatosGeneralesChanged = React.useCallback(async (e) => {
        var field = e.dataField;
        var value = e.value;
        var catToRefresh = [];
        var refreshAllData = false;

        if (formDatosGeneralesRef.current) {
            var formDatosGenerales = formDatosGeneralesRef.current.instance();

            if (value) {
                for (var sectionIndex in invoiceCfg.secciones) {
                    var seccion = invoiceCfg.secciones[sectionIndex];

                    for (var campoIndex in seccion.campos) {
                        var campo = seccion.campos[campoIndex];

                        if (campo.custrecord_al_kiosco_cfgd_clave === field) {
                            if (campo.custrecord_al_kiosco_cfg_refrescar_cat) {
                                var catalogos = JSON.parse(campo.custrecord_al_kiosco_cfg_catalogos);
                                setVisibleLoadPanel(true);

                                for (var catalogoIndex in catalogos) {
                                    var catalogo = catalogos[catalogoIndex];

                                    catToRefresh.push(catalogo);
                                }

                                setVisibleLoadPanel(false);
                            }
                            if (!isRefreshing && campo.custrecord_al_kiosco_cfg_refrescar_datos) {
                                setIsRefreshing(true);

                                setVisibleLoadPanel(true);

                                let apiName = 'kioscoAPI';
                                let path = '/kioscoGetCustomerData';

                                let options = {
                                    headers: {
                                        'Content-Type': 'application/json'
                                    },
                                    body: {
                                        payload: invoicePayload,
                                        field: field
                                    }
                                };

                                var response = await post({
                                    apiName,
                                    path,
                                    options
                                }).response;

                                var dataGet = await response.body.json();

                                if (campo.custrecord_al_kiosco_cfg_refrescar_datos === 'Toda la Forma') {
                                    setInvoicePayload(dataGet);
                                    setTickets([]);
                                    setBtnSearchDisabled(false);
                                    refreshAllData = true;
                                }
                                else {
                                    var fields = Object.keys(dataGet);

                                    for (var fieldIndex in fields) {
                                        var fieldAux = fields[fieldIndex];

                                        try {
                                            formDatosGenerales.updateData(fieldAux, dataGet[fieldAux]);
                                        }
                                        catch (e) {

                                        }
                                    }
                                }

                                setVisibleLoadPanel(false);

                                setIsRefreshing(false);
                            }
                        }
                    }
                }
            }
            else {
                for (var sectionIndex in invoiceCfg.secciones) {
                    var seccion = invoiceCfg.secciones[sectionIndex];

                    for (var campoIndex in seccion.campos) {
                        var campo = seccion.campos[campoIndex];

                        if (campo.custrecord_al_kiosco_cfgd_clave === field) {
                            if (campo.custrecord_al_kiosco_cfg_refrescar_datos) {
                                if (campo.custrecord_al_kiosco_cfg_refrescar_datos === 'Toda la Forma') {
                                    setVisibleLoadPanel(true);

                                    formDatosGenerales.clear();
                                    setCatalogs({});
                                    setTickets([]);
                                    setBtnSearchDisabled(false);

                                    setVisibleLoadPanel(false);
                                }
                                else if (campo.custrecord_al_kiosco_cfg_refrescar_datos === 'Seccion') {
                                    for (var campoIndex2 in seccion.campos) {
                                        var campo2 = seccion.campos[campoIndex2];

                                        formDatosGenerales.updateData(campo2.custrecord_al_kiosco_cfgd_clave, undefined);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        if (catToRefresh.length > 0) {
            await getCatalog(catToRefresh, refreshAllData);
        }
    }, [invoiceCfg, formDatosGeneralesRef, getCatalog, invoicePayload, isRefreshing]);

    const onInitialized = React.useCallback((e) => {
        setFormInstance(e);
    }, []);

    const getDynamicEditorOptions = React.useCallback((dataField) => {
        let options = { ...fieldEditorOptions[dataField] };

        if (typeof options.items === 'string') {
            const match = options.items.match(/^catalogs\.(\w+)$/);
            if (match) {
                const catalogKey = match[1];
                options.items = catalogs[catalogKey] || [];
            }
        }

        return options;
    }, [fieldEditorOptions, catalogs]);


    const fnGetTicket = React.useCallback(async (e) => {
        setVisibleLoadPanel(true);

        let apiName = 'kioscoAPI';
        let path = '/kioscoGetTicket';

        let options = {
            headers: {
                'Content-Type': 'application/json'
            },
            body: {
                payload: invoicePayload
            }
        };

        var response = await post({
            apiName,
            path,
            options
        }
        ).response;

        var dataGet = await response.body.json();

        setVisibleLoadPanel(false);

        if (dataGet.success) {
            var exists = _.find(tickets, dataGet.data);

            if (exists) {
                Swal.fire({
                    title: 'Error!',
                    text: invoiceCfg.custrecordcustrecord_al_kiosco_cfg_dupl,
                    icon: 'error',
                    cancelButtonText: 'Cerrar'
                });
            }
            else {
                var gridTickets = gridTicketsRef.current.instance();
                gridTickets.getDataSource().store().insert(dataGet.data).then(() => {
                    gridTickets.refresh();
                });

                if (!invoiceCfg.custrecord_al_kiosco_cfg_maximo) {
                    setBtnSearchDisabled(false);
                }
                else {
                    if (tickets.length >= invoiceCfg.custrecord_al_kiosco_cfg_maximo) {
                        setBtnSearchDisabled(true);
                    }
                    else {
                        setBtnSearchDisabled(false);
                    }
                }
            }

            if (formDatosGeneralesRef.current) {
                var formDatosGenerales = formDatosGeneralesRef.current.instance();

                // Limpiamos los campos despues de buscar
                for (var clearAfterSearchIndex in invoiceCfg.cleanAfterSearch) {
                    var singleClearAfterSearch = invoiceCfg.cleanAfterSearch[clearAfterSearchIndex];

                    formDatosGenerales.updateData(singleClearAfterSearch, undefined);
                }
            }
        }
        else {
            Swal.fire({
                title: 'Error!',
                text: dataGet.message,
                icon: 'error',
                cancelButtonText: 'Cerrar'
            });
        }

    }, [invoicePayload, gridTicketsRef, tickets, invoiceCfg, formDatosGeneralesRef]);

    const onRowCRUDTicket = React.useCallback((eventName) => {
        if (!invoiceCfg.custrecord_al_kiosco_cfg_maximo) {
            setBtnSearchDisabled(false);
        }
        else {
            if (tickets.length >= invoiceCfg.custrecord_al_kiosco_cfg_maximo) {
                setBtnSearchDisabled(true);
            }
            else {
                setBtnSearchDisabled(false);
            }
        }
    }, [tickets, invoiceCfg]);

    const downloadFile = React.useCallback((data) => {
        const url = window.URL.createObjectURL(
            new Blob([data.value]),
        );
        const link = document.createElement('a');

        if (data.value.indexOf('<?xml') < 0) {
            link.href = 'data:application/pdf;base64,' + data.value;
        }
        else {
            link.href = url;
        }

        link.setAttribute(
            'download',
            data.data.filename + (data.value.indexOf('<?xml') >= 0 ? '.xml' : '.pdf'),
        );

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
    }, []);

    const buttonCellRender = React.useCallback((data) => {
        if (data.data.filename) {
            return (
                <button onClick={() => downloadFile(data)}>
                    <FontAwesomeIcon icon={faDownload} size="lg" />
                </button>
            )
        }
        else {
            return (
                <div></div>
            )
        }
    }, [downloadFile]);

    return (
        <div>
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                visible={visibleLoadPanel}
                showIndicator={true}
                message="Por favor espere..."
                shading={true}
                showPane={true}
                hideOnOutsideClick={false}
            />
            <Popup
                visible={popupVisible}
                onHiding={hidePopupInfo}
                dragEnabled={true}
                hideOnOutsideClick={true}
                showCloseButton={true}
                resizeEnabled={true}
                showTitle={false}
                width="auto"
                height="auto"
                contentRender={renderTicketContent}
            >
            </Popup>

            <div className='ml-3 mr-3 p-5 bg-white'>
                <Form
                    key="formInvoice"
                    id="formInvoice"
                    labelMode={invoiceCfg.custrecord_al_kiosco_cfg_label_mode}
                    formData={invoicePayload}
                    readOnly={false}
                    showColonAfterLabel={false}
                    labelLocation={invoiceCfg.custrecord_al_kiosco_cfg_label_loc}
                    onFieldDataChanged={onFieldDatosGeneralesChanged}
                    ref={formDatosGeneralesRef}
                    colCount={1}
                    onInitialized={onInitialized}
                >
                    {invoiceCfg.secciones.map((seccion, rowIndex) => (
                        !seccion.custrecord_al_kiosco_cfg_seccion_detalle ? (
                            <GroupItem key={rowIndex} caption={seccion.name} colCount={seccion.custrecord_al_kiosco_cfg_seccion_col}>
                                {seccion.campos.map((campo, colIndex) => {
                                    return campo.custrecord_al_kiosco_cfgd_tipodato !== 'button' ? (
                                        <Item
                                            key={campo.internalid}
                                            dataField={campo.custrecord_al_kiosco_cfgd_clave}
                                            colSpan={campo.custrecord_al_kiosco_cfgd_colspan}
                                            editorOptions={getDynamicEditorOptions(campo.custrecord_al_kiosco_cfgd_clave)}
                                            editorType={campo.editorType}
                                            visible={!campo.custrecord_al_kiosco_cfgd_ocultar_col}
                                            displayFormat={campo.displayFormat}
                                            format={campo.format}
                                        >
                                            <Label text={campo.custrecord_al_kiosco_cfgd_nombre} />
                                            {campo.custrecord_al_kiosco_cfgd_requerido && <RequiredRule message={campo.custrecord_al_kiosco_cfgd_nombre + " es requerido"} />}
                                            {campo.custrecord_al_kiosco_cfgd_validaemail && <EmailRule message="El campo debe ser un email válido" />}
                                            {campo.custrecord_al_kiosco_cfgd_regexp !== '' && (
                                                <PatternRule message="Valor Incorrecto" pattern={RegexParser(campo.custrecord_al_kiosco_cfgd_regexp)} />
                                            )}
                                        </Item>
                                    ) : (
                                        <ButtonItem key={campo.internalid} cssClass="flex items-end justify-start">
                                            <ButtonOptions
                                                type={campo.custrecord_al_kiosco_cfgd_btntype}
                                                icon={campo.custrecord_al_kiosco_cfgd_icono}
                                                text={campo.custrecord_al_kiosco_cfgd_nombre}
                                                onClick={(e) => fnGetTicket(e)}
                                                disabled={btnSearchDisabled}
                                            />
                                        </ButtonItem>
                                    );
                                })}
                            </GroupItem>
                        ) : (
                            <GroupItem key={rowIndex} caption={seccion.name}>
                                <DataGrid
                                    hey="gridTickets"
                                    id="gridTickets"
                                    columnsAutoWidth={true}
                                    dataSource={tickets}
                                    allowColumnReordering={false}
                                    allowColumnResizing={false}
                                    sorting={false}
                                    showBorders={true}
                                    rowAlternationEnabled={true}
                                    showRowLines={true}
                                    showColumnLines={true}
                                    ref={gridTicketsRef}
                                    onRowRemoved={onRowCRUDTicket}
                                >
                                    <Editing
                                        mode="row"
                                        allowUpdating={false}
                                        allowDeleting={true}
                                        allowAdding={false}
                                        useIcons={true}
                                    />
                                    {seccion.campos.map((campo, colIndex) => (
                                        campo.custrecord_al_kiosco_cfgd_tipodato === 'button' ?
                                            (
                                                <Column key={campo.custrecord_al_kiosco_cfgd_clave} dataField={campo.custrecord_al_kiosco_cfgd_clave} width={campo.custrecord_al_kiosco_cfgd_width} alignment="center" caption={campo.custrecord_al_kiosco_cfgd_nombre} cellRender={buttonCellRender} >
                                                </Column>
                                            ) : (
                                                campo.custrecord_al_kiosco_cfgd_tipodato !== 'currency' ?
                                                    (
                                                        <Column key={campo.custrecord_al_kiosco_cfgd_clave} dataField={campo.custrecord_al_kiosco_cfgd_clave} width={campo.custrecord_al_kiosco_cfgd_width} dataType={campo.custrecord_al_kiosco_cfgd_tipodato} caption={campo.custrecord_al_kiosco_cfgd_nombre} visible={!campo.custrecord_al_kiosco_cfgd_ocultar_col} >
                                                        </Column>
                                                    ) : (
                                                        <Column key={campo.custrecord_al_kiosco_cfgd_clave} dataField={campo.custrecord_al_kiosco_cfgd_clave} width={campo.custrecord_al_kiosco_cfgd_width} dataType="number" caption={campo.custrecord_al_kiosco_cfgd_nombre} visible={!campo.custrecord_al_kiosco_cfgd_ocultar_col} >
                                                            <Format
                                                                type="currency"
                                                                precision={2}

                                                            />
                                                        </Column>
                                                    )
                                            )
                                    ))}
                                </DataGrid>
                            </GroupItem>
                        )
                    ))}
                </Form>
            </div>

            {
                (invoiceCfg.custrecord_al_kiosco_cfg_ticket_ejemplo ? (
                    <button
                        className={styles.custrecord_al_kiosco_cfg_class_ejemplo}
                        onClick={() => ticketButton()}
                    >
                        <FontAwesomeIcon icon={faBallotCheck} size='lg' />  Ejemplo de Ticket
                    </button>
                ) : (
                    <div></div>
                ))
            }

            <button
                className={styles.custrecord_al_kiosco_cfg_class_facturar}
                onClick={() => invoiceButton()}
            >
                <FontAwesomeIcon icon={faBadgeCheck} size="lg" /> Facturar
            </button>

            {
                (invoiceCfg.custrecord_al_kiosco_cfg_tipo_envio === 'Manual' || invoiceCfg.custrecord_al_kiosco_cfg_tipo_envio === 'Ambos' ? (
                    <button
                        className={styles.custrecord_al_kiosco_cfg_class_enviar}
                        onClick={() => emailButton()}
                    >
                        <FontAwesomeIcon icon={faEnvelope} size='lg' />  Enviar Correo
                    </button>
                ) : (
                    <div></div>
                ))
            }
        </div>
    );
};